import api from '@/apis'
import * as TYPES from './mutationTypes'

export default {}
